
import { Component, Prop, Vue } from "vue-property-decorator";
import TeacherIcon from "./TeacherIcon.vue";
import AudioCaptureButton from "src/modules/player/components/controls/other/AudioCaptureButton.vue";
import {midiDispatcher} from "src/modules/midi/MidiDispatcher";

@Component({
  components: { TeacherIcon, AudioCaptureButton }
  })
export default class TeacherMainButton extends Vue {
  @Prop({ type: Boolean, required: true }) readonly isChatButtonDisplayed!: boolean;
  @Prop({ type: Boolean, required: true }) readonly isButtonShaking!: boolean;
  @Prop({ type: Boolean, required: true }) readonly isInPlayer!: boolean;
  @Prop({ type: Boolean, required: true }) readonly isConvDisplayed!: boolean;
  @Prop({ type: Number, required: true }) readonly chatBottom!: number;
  @Prop({ type: Boolean, required: true }) readonly showActionButtons!: boolean;
  @Prop({ type: Boolean, required: true }) readonly isListening!: boolean;
  @Prop({ type: Boolean, required: true }) readonly speechRecognitionNotAvailable!: boolean;

  get chatBtnStyle() {
    const style = {};
    if (this.chatBottom) {
      style.bottom = this.chatBottom + 'px';
    }
    return style;
  }

  handleMainButtonClick() {
    if (this.isConvDisplayed) {
      this.$emit('update:isConvDisplayed', false);
    }
    else {
      if (!this.isInPlayer) {
        this.$emit('open-conversation');
      }
      else {
        this.$emit('handleMainButtonClick');
      }
    }
  }

  get isMidiActive() {
    return midiDispatcher.state.isActive
  }
}
